import { cloneDeep } from 'lodash'
import { calculateCellContentColumnMinWidth, isCellContentColumnWidth } from '../../../plugins/cell-content-width'
export const keeps = 30
/*
  递归生成显示的columns配置 并确保顺序的连续性。
  egg:

  [{key: 'a', children: [{key: 'a-1'}]}, {key: 'b'}]
  ->
  [{key: 'a', children: [{key: 'a-1'}]}, {key: 'a-1'}, {key: 'b'}]

*/
const key = 'key'

function getAllChildKeys(children, acc) {
  const keys = new Set()

  for (const child of children) {
    const childKey = child[key]
    keys.add(childKey)
    getAllChildKeys(child.children || [], [...acc, childKey]).forEach((subKey) => {
      keys.add(subKey)
    })
  }

  return Array.from(keys)
}

export function createVisibleFlatColumns (cols) {
  const stack = cloneDeep(cols)

  const visibleFlatColumns = []
  const collapsedMap_ = new Map()
  const colsMap = {}
  while (stack.length) {
    const current = stack.shift()
    const currentKey = current[key]
    const {
      children = [],
      fixed,
      width,
      parentNodeKeys = [],
      childKeys = [],
      parentNodeKey,
      resizable = true,
      minWidth,
      ...reset
    } = current
    const { level = 1, collapsed = false, collapseKeys = [] } = reset
    if (collapseKeys.length) {
      for (const k of collapseKeys) {
        collapsedMap_.set(k, collapsed)
      }
    }
    const hasChildren = !!children.length
    if (hasChildren) {
      // 继承父级的fixed
      const parentNodeKey = currentKey
      stack.unshift(
        ...children.map((child) => ({
          ...child,
          parentNodeKeys: [...parentNodeKeys, parentNodeKey],
          fixed,
          parentNodeKey,
          level: level + 1
        }))
      )
    }
    const item = {
      ...current,
      width: minWidth || width,
      minWidth,
      parentNodeKeys,
      children,
      level,
      resizable,
      childKeys: getAllChildKeys(children, childKeys)
    }
    // 全局处理column width
    if (item.width) {
      if (!isCellContentColumnWidth(item)) {
        item.width = parseInt(item.width)
      } else {
        item._autoWidthByCellContent = true
        item.width = calculateCellContentColumnMinWidth(item)
      }
    }
    // item.width && (item.width = Number(item.width))
    visibleFlatColumns.push(item)
    colsMap[currentKey] = item
  }
  // 子级的折叠状态跟随父级的状态
  collapsedMap_.forEach((value, key) => {
    const { childKeys = [] } = colsMap[key] || {}
    if (childKeys.length) {
      childKeys.forEach(childKey => {
        collapsedMap_.set(childKey, value)
      })
    }
  })
  const collapsedMap = Object.fromEntries(collapsedMap_.entries())
  return { visibleFlatColumns, collapsedMap }
}

// 根据maxlevel生成rows
function initRows (maxLevel) {
  return Array.from({ length: maxLevel }, () => [])
}

function countColSpan(col, collapsedMap = {}, memo = new Map()) {
  if (memo.has(col)) {
    return memo.get(col)
  }
  let colSpan = 0
  if (col.children && col.children.length > 0) {
    for (const child of col.children) {
      if (!(child.show !== false && !collapsedMap[child.key])) {
        continue
      }
      colSpan += countColSpan(child, collapsedMap, memo)
    }
  } else {
    colSpan += 1
  }
  memo.set(col, colSpan)
  return colSpan
}

function countRowSpan (col, maxLevel) {
  return col.children && col.children.length ? 1 : maxLevel - col.level + 1
}
// 根据拉平的数组，填充数据，拉平时保证了数据的顺序，所以按level添加
function processingRows (data, headerHeight, maxLevel, collapsedMap) {
  const rows = initRows(maxLevel)
  for (let i = 0; i < data.length; i++) {
    const col = data[i]
    const rowSpan = countRowSpan(col, maxLevel)
    const colSpan = countColSpan(col, collapsedMap)
    const height = parseFloat(headerHeight) * rowSpan // 高度使用 props
    Object.assign(col, { rowSpan, colSpan, headerHeight: height })
    rows[col.level - 1].push(col)
  }
  return rows
}


// 生成渲染表头结构的二维数组
export function createColumnRows (columns = [], headerHeight, maxLevel, collapsedMap) {
  const columnsRows = processingRows(columns, headerHeight, maxLevel, collapsedMap)
  return columnsRows
}







// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/utils/columns.js